<div class="col-10 mt-4 px-6">
    <div>
        <h3>For Aircraft Owners:</h3>
        <ul>
            <li>You do <b>not</b> need an FAA Tracking Number (FTN) to log in to USAS.</li>
            <li>You <b>will need</b> your aircraft registration <b>N-Number</b> and <b>serial number.</b></li>
            <li><a type="button" class="link-button" href="https://registry.faa.gov/aircraftinquiry/"
                title="Click" target="_blank">Click here</a> to look up your aircraft’s N-Number and serial number.</li>
        </ul>
    </div>
    <div>
        <h3>For Airmen and Other Certificate Holders:</h3>
        <ul>
            <li>You <b>may be required</b> to provide your <b>FAA Tracking Number (FTN)</b> and <b>date of birth (DOB)</b>.</li>
            <li>You can find your FTN through your <a type="button" class="link-button" href="https://medxpress.faa.gov/MedXpress/Disclaimer.aspx"
                title="Click" target="_blank">MedXPress</a> profile or <a type="button" class="link-button" href="https://iacra.faa.gov/IACRA/Default.aspx"
                title="Click" target="_blank">IACRA</a> profile.</li>
            <li>Existing Certificate holders your FTN can be found via <a type="button" class="link-button" href="https://amsrvs.registry.faa.gov/amsrvs/"
                title="Click" target="_blank">Airmen Services</a>.</li>
            <li>If you don’t have an Airmen Services account, you can create one <a type="button" class="link-button" href="https://amsrvs.registry.faa.gov/amsrvs/"
                title="Click" target="_blank">here</a>.</li>
            <li>If you don’t have an FTN (new airmen), register with <a type="button" class="link-button" href="https://iacra.faa.gov/IACRA/Default.aspx"
                title="Click" target="_blank">IACRA</a> to create one before logging in to USAS.</li>
        </ul>
    </div>
</div>